export default {
  path: '/company',
  component: () => import('@/layout/Empty.vue'),
  meta: {
    personVerify: true
  },
  children: [
    {
      path: 'add',
      component: () => import('@/views/user/company/AddCompany')
    }
  ]
}
